import Axios from "axios";
import {
    SET_HRM_EMPLOYEE_LIST,
    UNSET_HRM_EMPLOYEE_LIST,
    SET_HRM_EMPLOYEE_PERMISSION_WISE_LIST,
    UNSET_HRM_EMPLOYEE_PERMISSION_WISE_LIST,
    SET_HRM_TEAM_WISE_EMPLOYEE_LIST,
    UNSET_HRM_TEAM_WISE_EMPLOYEE_LIST,
    UNSET_HRM_DEPERTMENT_WISE_EMPLOYEE_LIST,
    SET_HRM_DEPERTMENT_WISE_EMPLOYEE_LIST,
  } from "@/store/mutation-types";
import { getHrmEmployeeList, getHrmEmployeePermissionWiseList, getHrmTeamWiseEmployeeList } from "@/store/api";
// initial state
const state = {
  getHrmEmployeeList: [],
  getHrmDepartmentWiseEmployeeList:[],
  getHrmEmployeePermissionWiseList: [],
  getHrmTeamwiseEmployeeList: [],
};

const getters = {
  getHrmEmployeeList(state) {
    return state.getHrmEmployeeList;
  },
  getDepartmentWiseEmployeeList(state){
    return state.getHrmDepartmentWiseEmployeeList;
  },
  getHrmEmployeePermissionWiseList(state) {
    return state.getHrmEmployeePermissionWiseList;
  },
  getHrmTeamwiseEmployeeList(state) {
    return state.getHrmTeamwiseEmployeeList;
  },
};
const mutations = {
  [SET_HRM_EMPLOYEE_LIST](state, data) {
    state.getHrmEmployeeList = data;
  },
  [UNSET_HRM_EMPLOYEE_LIST](state) {
    state.getHrmEmployeeList = [];
  },

  [SET_HRM_DEPERTMENT_WISE_EMPLOYEE_LIST](state, data) {
    state.getHrmDepartmentWiseEmployeeList = data;
  },
  [UNSET_HRM_DEPERTMENT_WISE_EMPLOYEE_LIST](state) {
    state.getHrmDepartmentWiseEmployeeList = [];
  },

  [SET_HRM_EMPLOYEE_PERMISSION_WISE_LIST](state, data) {
    state.getHrmEmployeePermissionWiseList = data;
  },
  [UNSET_HRM_EMPLOYEE_PERMISSION_WISE_LIST](state) {
    state.getHrmEmployeePermissionWiseList = [];
  },
  [SET_HRM_TEAM_WISE_EMPLOYEE_LIST](state,data) {
    state.getHrmTeamwiseEmployeeList = data;
  },
  [UNSET_HRM_TEAM_WISE_EMPLOYEE_LIST](state) {
    state.getHrmTeamwiseEmployeeList = [];
  }

};

const actions = {
  getHrmEmployeeList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getHrmEmployeeList, data)
        .then(function (response) {
          commit('SET_HRM_EMPLOYEE_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_HRM_EMPLOYEE_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },




  getDepartmentWiseEmployeeList({ commit }, data) {
    return new Promise((resolve, reject) => {
      if (!data || !data.department_id) {
        commit('UNSET_HRM_DEPERTMENT_WISE_EMPLOYEE_LIST');
        resolve();
        return;
      }
      Axios.get(getHrmEmployeeList, { params: data })
        .then(function (response) {
          commit('SET_HRM_DEPERTMENT_WISE_EMPLOYEE_LIST', response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_HRM_DEPERTMENT_WISE_EMPLOYEE_LIST');
          reject(error);
        })
        .then(() => {
        });
      });
  },

  getHrmEmployeePermissionWiseList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getHrmEmployeePermissionWiseList, data)
        .then(function (response) {
          commit('SET_HRM_EMPLOYEE_PERMISSION_WISE_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_HRM_EMPLOYEE_PERMISSION_WISE_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
  getTeamWiseEmployeeList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getHrmTeamWiseEmployeeList, { params: data })
        .then(function (response) {
          commit('SET_HRM_TEAM_WISE_EMPLOYEE_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_HRM_TEAM_WISE_EMPLOYEE_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
